module.exports = __webpack_public_path__ + "static/img/pos_pay_machine.65aee21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/pos_pay_machine.png
// module id = qDO/
// module chunks = 8